// MUI-free copy of Ui-components/ios-development/IosProcessIndex.
import {memo} from 'react';
import parse from 'html-react-parser';
import Container from '@/components/atoms/Container';
import SectionHeader from '@/components/molecules/SectionHeader';
import styles from './IosProcessIndex.module.scss';

export interface ProcessIndexStep {
    title: string;
    paragraphs: string[];
}

interface IosProcessIndexProps {
    heading: string;
    subheading?: string;
    steps: ProcessIndexStep[];
}

const pad = (n: number) => String(n).padStart(2, '0');

const IosProcessIndex = ({heading, subheading, steps}: IosProcessIndexProps) => (
    <div>
        <Container>
            <SectionHeader heading={heading} subheading={subheading && parse(subheading)} className={styles.headerWrap} />

            <ol className={styles.list}>
                {steps?.map((step, i) => (
                    <li key={step.title} className={styles.row}>
                        <span className={`font-headers process-index-number ${styles.number}`} aria-hidden="true">
                            {pad(i + 1)}
                        </span>

                        <div>
                            <h3 className={`font-headers ${styles.title}`}>{step.title}</h3>
                            {step.paragraphs.map((paragraph) => (
                                <p key={paragraph} className={`font-regular-text ${styles.paragraph}`}>
                                    {parse(paragraph)}
                                </p>
                            ))}
                        </div>
                    </li>
                ))}
            </ol>
        </Container>
    </div>
);

export default memo(IosProcessIndex);
